import React from 'react';

import {
  OrderStatusName,
  OverallOrderStatusName,
  useOrderSourceInformationWidgetQuery
} from 'generated/graphql';

import { referralUtil } from 'modules/layer00';



export type IPaymentStatus = 'failed' | 'completed' | 'pending' | 'cancelled';

export interface IData {
  isSuperAdmin: boolean;

  orderNumber: string;
  orderSourceDisplayName: string;

  overallOrderStatusName: OverallOrderStatusName;
  overallOrderStatusDisplayName: string;
  urlToCustomerOrderDetail: string;

  paymentStatusName: IPaymentStatus;
  urlToE1: string;
  urlToStore: string;
  urlToNetSuite: string;
}

export function useQuery(orderId: string) {
  const queryTuple = useOrderSourceInformationWidgetQuery({
    variables: {
      orderId
    }
  });

  const wrappedTuple = React.useMemo(
    () => {
      const order = queryTuple.data?.order;
      const statusName = order?.status.name ?? 'pending';
      const data: IData = {
        paymentStatusName: __orderStatus2PaymentStatus(statusName),
        isSuperAdmin: queryTuple.data?.loggedInUser?.isSuperAdmin ?? false,
        orderNumber: order?.orderNumber ?? '',
        orderSourceDisplayName: order?.store.type.displayName ?? '',
        overallOrderStatusName: order?.overallOrderStatus.name ?? 'open',
        overallOrderStatusDisplayName: order?.overallOrderStatus.displayName ?? '',

        urlToCustomerOrderDetail: referralUtil.genReferralLink({
          storeId: order?.store.id ?? '',
          customerEmail: order?.customer.email ?? '',
          orderNumber: order?.orderNumber ?? ''
        }),
        urlToE1: order?.e1DocumentIndex?.urlToE1Record ?? '',
        urlToStore: order?.urlToStoreRecord ?? '',
        urlToNetSuite: order?.netSuiteRecord?.recordUrl ?? ''
      };

      return {
        ...queryTuple,
        data
      };
    },
    [queryTuple]
  );

  return wrappedTuple;
}



function __orderStatus2PaymentStatus(statusName: OrderStatusName): IPaymentStatus {
  if (statusName === 'processing' || statusName === 'refunded' || statusName === 'completed') {
    return 'completed';
  } else if (statusName === 'cancelled') {
    return 'cancelled';
  } else if (statusName === 'failed') {
    return 'failed';
  } else if (statusName === 'onHold' || statusName === 'pending') {
    return 'pending';
  } else {
    return 'pending';
  }
}
